// extracted by mini-css-extract-plugin
export default {"wrapper":"twoPlayersPs_wrapper__6f5By","button":"twoPlayersPs_button__r5e+o"};